import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import type { VimeoVideo } from '../services/vimeo-api';
import type { VideoOpenDetail } from './imos-video-modal';

@customElement('imos-video-card')
export class ImosVideoCard extends LitElement {
  @property({ type: Object }) video!: VimeoVideo;
  @property({ type: String, attribute: 'minutes-label' }) minutesLabel = 'Minutes';

  protected createRenderRoot(): this {
    return this;
  }

  private openVideo(): void {
    const detail: VideoOpenDetail = {
      title: this.video.title,
      videoId: this.video.videoId,
      posterUrl: this.video.poster,
      embedHtml: this.video.embedHtml,
    };
    window.dispatchEvent(
      new CustomEvent('imos-video-open', { bubbles: true, composed: true, detail }),
    );
  }

  protected render() {
    const v = this.video;
    if (!v) return nothing;

    return html`
      <div
        class="bg-white dark:bg-black text-gray-300! dark:!text-gray-250 cursor-pointer"
        @click=${() => this.openVideo()}
      >
        <div>
          <div>
            <img src=${v.poster} alt="" />
          </div>
          <div class="flex flex-col p-xs pt-xs">
            <div class="leading-tight mb-xs font-bold dark:text-white text-sm">${v.title}</div>
            <div>
              <ul class="badge-list">
                ${repeat(
                  v.tags,
                  (t) => t.value,
                  (tag) => html`<li><span class="badge">${tag.title}</span></li>`,
                )}
              </ul>
              <div class="border-t border-main my-xs"></div>
              <div class="flex items-center justify-between text-xs leading-trim">
                <div>
                  ${v.date ? html`<span>${v.date}</span>` : nothing}
                  ${v.duration
                    ? html`<span>&ensp;|&ensp;${v.duration} ${this.minutesLabel}</span>`
                    : nothing}
                </div>
                ${v.downloadUrl
                  ? html`<a
                      href=${v.downloadUrl}
                      download
                      @click=${(e: Event) => e.stopPropagation()}
                      class="text-brand dark:text-white hover:text-brand-dark"
                      ><i class="icon--imos-webicon_downloads"></i
                    ></a>`
                  : nothing}
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}
